export interface OrderDraft {
  deliveryType: "address" | "pickup";
  dispatchMethod: string;
  locationCode: string;
  pickupLocationName: string;
  shipToCode: string;
  shipToName: string;
  shipToAddress: string;
  shipToCity: string;
  shipToPostcode: string;
  deliveryInstructions: string;
  pickupInstructions: string;
  requestedDeliveryDate: string;
  dropShipSupplier: string;
  dropShipLeadTime: string;
  isAlternateAddress: boolean;
  contactPerson: string;
  contactPhone: string;
  dispatchLocation: string;
  dispatchLocationName: string;
  specialInstructions: string;
  mixName: string;
  paddockSize: string;
  paddockName: string;
  sowingRate: string;
  treatment: string;
  mixLocation: string;
  emailQuote: boolean;
  quoteEmail: string;
  deferredDays: number;
  deferredRate: number;
}

const KEY = "carrfields-order-draft";
const emptyDraft: OrderDraft = {
  deliveryType: "address",
  dispatchMethod: "carrfields",
  locationCode: "",
  pickupLocationName: "",
  shipToCode: "",
  shipToName: "",
  shipToAddress: "",
  shipToCity: "",
  shipToPostcode: "",
  deliveryInstructions: "",
  pickupInstructions: "",
  requestedDeliveryDate: "",
  dropShipSupplier: "",
  dropShipLeadTime: "",
  isAlternateAddress: false,
  contactPerson: "",
  contactPhone: "",
  dispatchLocation: "",
  dispatchLocationName: "",
  specialInstructions: "",
  mixName: "",
  paddockSize: "",
  paddockName: "",
  sowingRate: "",
  treatment: "",
  mixLocation: "",
  emailQuote: false,
  quoteEmail: "",
  deferredDays: 0,
  deferredRate: 10,
};

export function getOrderDraft(): OrderDraft {
  try {
    return {
      ...emptyDraft,
      ...(JSON.parse(
        sessionStorage.getItem(KEY) || "{}",
      ) as Partial<OrderDraft>),
    };
  } catch {
    return { ...emptyDraft };
  }
}

export function setOrderDraft(patch: Partial<OrderDraft>): OrderDraft {
  const next = { ...getOrderDraft(), ...patch };
  sessionStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function clearOrderDraft(): void {
  sessionStorage.removeItem(KEY);
}
